import { memo, useEffect } from 'react'
import { Provider } from 'react-redux'
import { useRoutes } from 'react-router-dom'

import { DialogAlert } from '@components'
import { CssBaseline, ThemeProvider } from '@mui/material'

import { BaseAPI } from '@services/ApiServices'

import { store } from './store'
import theme from './theme'
import { appRoutes } from './router'

const AppRoutes = () => {
  const element = useRoutes(appRoutes)

  useEffect(() => {
    const syncBaseApiUser = () => {
      const { user } = store.getState().auth
      if (user) {
        BaseAPI.init(user)
      }
    }

    syncBaseApiUser()
    return store.subscribe(syncBaseApiUser)
  }, [])

  return element
}

const App = () => (
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <DialogAlert />
      <AppRoutes />
    </ThemeProvider>
  </Provider>
)

export default memo(App)
